import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('de');

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'de' ? 'en' : 'de'));
  };

  const t = (key) => {
    const translations = {
      'de': {
        'infos': 'Infos',
        'meeting_rooms': 'Meeting- & Konferenzräume',
        'offices': 'Offices',
        'pedros': "Pedro's Café & Bar",
        'events': 'Veranstaltungen',
        'community': 'Community',
        'contact': 'Kontakt',
        'login': 'Anmelden',
        'logout': 'Abmelden',
        'book': 'Buchen',
        'more_info': 'Weitere Infos',
        'inquire': 'Anfragen',
        'call': 'Anrufen',
        'event_calendar': 'Eventkalender',
        'imprint': 'Impressum',
        'privacy': 'Datenschutz',
        'terms': 'AGB',
        'gallery': 'Galerie',
        'scroll_explore': 'SCROLLEN & ENTDECKEN',
        // User Profile
        'my_area': 'Mein Bereich',
        'welcome': 'Willkommen',
        'room_bookings': 'Raumbuchungen',
        'ticket_purchases': 'Ticket-Käufe',
        'profile': 'Profil',
        'edit_profile': 'Bearbeiten',
        'save': 'Speichern',
        'cancel': 'Abbrechen',
        'first_name': 'Vorname',
        'last_name': 'Nachname',
        'email': 'E-Mail',
        'phone': 'Telefon',
        'company': 'Firma',
        'upcoming_bookings': 'Anstehende Buchungen',
        'past_bookings': 'Vergangene Buchungen',
        'no_bookings': 'Keine Buchungen vorhanden',
        'no_orders': 'Keine Bestellungen vorhanden',
        'booking_number': 'Buchungsnummer',
        'booked_on': 'Gebucht am',
        'participants': 'Teilnehmer',
        'net': 'Netto',
        'vat': '+ 19% MwSt',
        'total': 'Gesamt',
        'addons': 'Zusatzoptionen',
        'cancel_booking': 'Stornieren',
        'confirmed': 'Bestätigt',
        'pending': 'Ausstehend',
        'cancelled': 'Storniert',
        'order_number': 'Bestellnummer',
        'tickets': 'Tickets',
        'show_qr': 'QR-Code anzeigen',
        'hide_qr': 'QR-Code ausblenden',
        'prices_excl_vat': 'Alle Preise zzgl. 19% MwSt.',
        'half_day': 'Halber Tag',
        'full_day': 'Ganzer Tag',
        'per_hour': '/Std.',
        'from': 'ab'
      },
      'en': {
        'infos': 'Infos',
        'meeting_rooms': 'Meeting & Conference Rooms',
        'offices': 'Offices',
        'pedros': "Pedro's Café & Bar",
        'events': 'Events',
        'community': 'Community',
        'contact': 'Contact',
        'login': 'Login',
        'logout': 'Logout',
        'book': 'Book Now',
        'more_info': 'More Info',
        'inquire': 'Inquire',
        'call': 'Call Now',
        'event_calendar': 'Event Calendar',
        'imprint': 'Imprint',
        'privacy': 'Privacy',
        'terms': 'Terms',
        'gallery': 'Gallery',
        'scroll_explore': 'SCROLL TO EXPLORE',
        // User Profile
        'my_area': 'My Area',
        'welcome': 'Welcome',
        'room_bookings': 'Room Bookings',
        'ticket_purchases': 'Ticket Purchases',
        'profile': 'Profile',
        'edit_profile': 'Edit',
        'save': 'Save',
        'cancel': 'Cancel',
        'first_name': 'First Name',
        'last_name': 'Last Name',
        'email': 'Email',
        'phone': 'Phone',
        'company': 'Company',
        'upcoming_bookings': 'Upcoming Bookings',
        'past_bookings': 'Past Bookings',
        'no_bookings': 'No bookings yet',
        'no_orders': 'No orders yet',
        'booking_number': 'Booking No.',
        'booked_on': 'Booked on',
        'participants': 'Participants',
        'net': 'Net',
        'vat': '+ 19% VAT',
        'total': 'Total',
        'addons': 'Add-ons',
        'cancel_booking': 'Cancel',
        'confirmed': 'Confirmed',
        'pending': 'Pending',
        'cancelled': 'Cancelled',
        'order_number': 'Order No.',
        'tickets': 'Tickets',
        'show_qr': 'Show QR Code',
        'hide_qr': 'Hide QR Code',
        'prices_excl_vat': 'All prices excl. 19% VAT.',
        'half_day': 'Half Day',
        'full_day': 'Full Day',
        'per_hour': '/hour',
        'from': 'from'
      }
    };
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
